module.exports = __webpack_public_path__ + "static/media/Justin Matejka.2cef6eb4.png";